import CrossPlatformDialog from '@/dialogs/components/CrossPlatformDialog'
import { SessionSettings } from './SessionSettings'
import { useRoomContext } from '@/RoomContext'
import useMiscRoomActions from '@/services/useMiscRoomActions'

type SessionSettingsDialogProps = {
    inSession?: boolean
    forceBrowserModal?: boolean
}

/**
 * Open/close state is triggered by roomState.isSettingModalOpen.
 * Use useMiscRoomActions.openSettingsModal() to open the dialog. This will
 * ensure that an already-open dialog that may be behind a window is refocused.
 */
export function SessionSettingsDialog(props: SessionSettingsDialogProps) {
    const className = 'pt-[40px] px-[10px]'

    const [roomState] = useRoomContext()

    const { closeSettingsModal } = useMiscRoomActions()

    if (roomState.isSettingModalOpen === null) {
        return null
    }

    return (
        <CrossPlatformDialog
            frameName="SessionSettingsModal"
            className={className}
            classNameNative="min-w-[880px]"
            classNameBrowser="w-full md:w-[880px] max-h-[90vh] h-[90vh]"
            forceBrowserModal={props.forceBrowserModal ?? false}
            overflow={false}
            onDefaultClose={closeSettingsModal}
            title="Session Settings"
        >
            <SessionSettings
                inSession={props.inSession}
                initialTab={roomState.isSettingModalOpen.tab}
                scrollToSection={roomState.isSettingModalOpen.section}
            />
        </CrossPlatformDialog>
    )
}
